.segmentedControl {
  border-radius: var(--mantine-radius-md);
  border: 1px solid var(--mantine-color-gray-2);
}
.segmentedControl[data-active="true"] {
  font-weight: 700;
  color: var(--mantine-color-white);
  .segmentedControlLabel[data-disabled] {
    color: var(--mantine-color-gray-7);
    background-color: var(--mantine-color-gray-3);
  }
}

.segmentedControlLabel {
  color: var(--mantine-color-gray-7);
}

.segmentedControlLabel[data-active="true"] {
  color: var(--mantine-color-white);
  font-weight: 700;
}

.segmentedControlLabel[data-disabled="true"] {
  color: var(--mantine-color-gray-7);
  background-color: var(--mantine-color-gray-1);
}
